import { useCallback } from 'react'
import { format, Locale } from 'date-fns'
import { fi } from 'date-fns/locale'

type useDateReturnType = {
  formatDate: (value: Date | number | string, formatType: string) => string
}

export const useDate = (localization: Locale = fi): useDateReturnType => {
  const formatDate = useCallback(
    (value: Date | number | string, formatType: string) => {
      return format(new Date(value), formatType, { locale: localization })
    },
    [localization]
  )

  return {
    formatDate
  }
}
